document.addEventListener('DOMContentLoaded', () => {
    const formEle = document.querySelector('.module form');

    if (!formEle) {
        return;
    }

    const btn = formEle.querySelector('button[type="submit"]');
    const inputs = formEle.querySelectorAll(".form-control, .form-check, input");

    btn.addEventListener("click", () => {
        inputs.forEach(function (element) {
            // if input field passes validation remove the error class, else add it
            if (element.checkValidity())
                element.classList.remove('error-input');
            else
                element.classList.add('error-input');
        });
    });
});
